import { gql } from '@apollo/client';

const query = gql`
  mutation CreateReview($input: CreateReviewInput!) {
    createReview(input: $input) {
      review {
        id
        userId
        rating
        displayName
        reviewState
        message
        createdAt
        reviewResponse {
          message
          id
        }
      }
    }
  }
`;

module.exports = query;
